/* global mixpanel */
export function resetAfterLogout () {
  mixpanel.reset()
}

export function logout () {
  mixpanel.track('Logout')
}



// WEBPACK FOOTER //
// ./app/mixpanel/logout/index.js